import { TEXT_CONVERSATION_URLS } from "../../apiConfig";
import { TEXT_ERRORS }  from "../../../common/constants/agentModule/textConstants.js";
import apiClient from "../../apiInstance";

export const getTextInfo = async () => {
    try {
      const response = await apiClient.get(TEXT_CONVERSATION_URLS.FETCH_TEXT_CONVERSATION_INFO);
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.FETCH_TEXT_INFO_ERROR, error);
      throw error;
    }
  };

  export const assignUsers = async ( id, assignedTo ) => {
    try {
      const response = await apiClient.post(TEXT_CONVERSATION_URLS.ASSIGN_USER, {
        id, assignedTo
      });
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.ASSIGN_USER_ERROR, error);
      throw error;
    }
  };

  export const endTextConversation = async ( id ) => {
    try {
      const response = await apiClient.post(TEXT_CONVERSATION_URLS.END_TEXT_CONVERSATION, {
        id
      });
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.END_CONVERSATION_ERROR, error);
      throw error;
    }
  };

  export const getTextConversationById = async (customerdataid) => {
    try {
      const response = await apiClient.get(TEXT_CONVERSATION_URLS.FETCH_TEXT_CONVERSATION_BY_ID, {
        params: { customerdataid: customerdataid }, // Explicitly setting the key-value pair
      });
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.FETCH_TEXT_CONVERSATION_BY_ID_ERROR, error);
      throw error;
    }
  };

  export const updateCaraResponseChat = async (data) => {
    try {
      const response = await apiClient.put(TEXT_CONVERSATION_URLS.UPDATE_CARA_RESPONSE_CHAT, {
        id: data.id,
        cararesponse: data.cararesponse,
        cararesponseapproved: data.cararesponseapproved,
        userguid: data.userguid
      });
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.UPDATE_CARA_RESPONSE_CHAT_ERROR, error.response?.data || error.message);
      throw error;
    }
  };

    export const approveAndSendChatConversation = async (data) => {
    try {
      const response = await apiClient.put(TEXT_CONVERSATION_URLS.APPROVE_SEND_CHAT, {
        id: data.id,
        cararesponseapproved: data.cararesponseapproved,
        userguid: data.userguid
      });
      return response.data;
    } catch (error) {
      console.error(TEXT_ERRORS.APPROVE_SEND_CHAT_ERROR, error.response?.data || error.message);
      throw error;
    }
  };
  